import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Grid2 } from "@mui/material";
import {
  MyCafeteriaApplicationsCard,
  MyCafeteriaArchiveApplicationsCard,
  MyCafeteriaBenefitsCard,
  MyCafeteriaDivider,
  MyCafeteriaDownloadsCard,
  MyCafeteriaSummaryCard,
} from "my-cafeteria/components";
import { useMyCafeteriaCurrentStatement } from "my-cafeteria/hooks";
import { OcPageNameTitle, OcPageTransition } from "oc/components";
import { useOcCurrentUserState } from "oc/hooks";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

export const MyCafeteriaPage = () => {
  const isMobile = useOcIsMobile();
  const { t } = useTranslation();

  let { contractCode } = useOcCurrentUserState();

  /** Use a custom hook to fetch data from the server */
  const {
    data: currentStatementData,
    loading: currentStatementLoading,
    error: currentStatementError,
  } = useMyCafeteriaCurrentStatement({
    contractCode,
  });

  return (
    <OcPageTransition>
      <OcPageNameTitle title={t("MY_CAFETERIA_PAGE_TITLE")} goBack={false} />
      <Box
        style={{
          backgroundColor: "#f1f3f4",
          width: "auto",
          padding: isMobile ? "0px 0px 16px 0px" : "0px 16px 16px 16px",
        }}
      >
        <MyCafeteriaSummaryCard
          data={currentStatementData}
          loading={currentStatementLoading}
          error={currentStatementError}
          isMobile={isMobile}
        />
        <MyCafeteriaDivider />
        <MyCafeteriaBenefitsCard
          contractCode={contractCode}
          currentStatement={currentStatementData}
          isMobile={isMobile}
        />
        <MyCafeteriaDivider />
        <Grid2
          container
          spacing={2}
          style={{ flexDirection: isMobile ? "column" : "row" }}
        >
          <Grid2
            id="my-cafeteria-benefits-card-statements"
            size={{ xs: 12, sm: 6, md: 6 }}
          >
            <MyCafeteriaApplicationsCard />
          </Grid2>
          <Grid2
            id="my-cafeteria-downloads-card"
            size={{ xs: 12, sm: 6, md: 6 }}
          >
            <MyCafeteriaDownloadsCard />
          </Grid2>
        </Grid2>
        <MyCafeteriaDivider />
        <MyCafeteriaArchiveApplicationsCard
          contractCode={contractCode}
          isMobile={isMobile}
        />
      </Box>
    </OcPageTransition>
  );
};

export default MyCafeteriaPage;
